'use client'

import type { ITokenService } from '@/core/services/tokens/token.service.interface'
import { AccountType } from '@/core/types/enums/account-type.enum'
import { create } from 'zustand'

type TokenState = {
  token: string | null
  accountType: AccountType
}

type TokenActions = ITokenService

export const useTokenStore = create<TokenState & TokenActions>((set, get) => ({
  token: null,
  accountType: AccountType.CUSTOMER,

  async getToken() {
    const { token, accountType } = get()
    return { token, accountType }
  },

  async setToken(token, accountType) {
    set({ token, accountType })
  },

  async clearToken() {
    set({ token: null, accountType: AccountType.CUSTOMER })
  },
}))

export const createMemroyTokenService = (): ITokenService => ({
  getToken: () => useTokenStore.getState().getToken(),
  setToken: (token, accountType) =>
    useTokenStore.getState().setToken(token, accountType),
  clearToken: () => useTokenStore.getState().clearToken(),
})
